import { Outlet } from "react-router-dom";

const Requests = () => <Outlet />;

export default Requests;
